export const certificates = [
    {
    name: 'Foundations of Digital Marketing and E-commerce',
    url: 'https://www.coursera.org/account/accomplishments/verify/74Y7H9TXNE7O',
    img: require('../images/certificates-img/Foundations-ofDigital-Marketing-and-Ecommerce-yanina-trekhleb.png'),
    date: 'Apr 2025 - Apr 2025',
    tags: [
      { name: 'digital marketing' },
      { name: 'e-commerce' },
      { name: 'email marketing' },
      { name: 'content performance analysis' },
      { name: 'customer engagement' },
    ],
  },
  {
    name: 'Selligent Marketing Cloud - Base',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/selligent_certificate_2024.png',
    img: require('../images/certificates-img/selligent_certificate_2024.png'),
    date: 'Sep 2024 - Sep 2024',
    tags: [
      { name: 'engage' },
      { name: 'marketing automation tool' },
      { name: 'omnichannel marketing platform' },
    ],
  },
  {
    name: 'Digital Marketer Walkthrough',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/marigold_digital_marketer_walkthrough_yanina_trekhleb.png',
    img: require('../images/certificates-img/marigold_digital_marketer_walkthrough_yanina_trekhleb.png'),
    date: 'May 2024 - May 2024',
    tags: [
      { name: 'engage' },
      { name: 'marketing automation tool' },
      { name: 'omnichannel marketing platform' },
    ],
  },
  {
    name: 'Selligent Marketing Cloud - Base',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/selligent_base.png',
    img: require('../images/certificates-img/selligent_base.png'),
    date: 'Sep 2022 - Sep 2022',
    tags: [
      { name: 'selligent' },
      { name: 'marketing automation tool' },
      { name: 'omnichannel marketing platform' },
    ],
  },
  {
    name: 'Customer Analytics and A/B Testing in Python',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/a-b-testing-data-camp.jpg',
    img: require('../images/certificates-img/a-b-testing-data-camp.jpg'),
    date: 'Jan 2022 - Jan 2022',
    tags: [
      { name: 'python' },
      { name: 'a/b testing' },
    ],
  },
  {
    name: 'Foundations: Data, Data, Everywhere',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Google-Data-Part1-Foundations-Data-Data-Everywhere.jpg',
    img: require('../images/certificates-img/Google-Data-Part1-Foundations-Data-Data-Everywhere.jpg'),
    date: 'Oct 2021 - Oct 2021',
    tags: [
      { name: 'data' },
      { name: 'data analysis' },
    ],
  },
  {
    name: 'Introduction to Python',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Introduction_to_Python_datacamp.jpg',
    img: require('../images/certificates-img/Introduction_to_Python_datacamp.jpg'),
    date: 'Sep 2021 - Oct 2021',
    tags: [
      { name: 'python' },
    ],
  },
  {
    name: 'Google Tag Manager Fundamentals',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Google-Tag-Manager-Fundamentals-Course_Certificate.jpg',
    img: require('../images/certificates-img/Google-Tag-Manager-Fundamentals-Course_Certificate.jpg'),
    date: 'Mar 2021 - Mar 2021',
    tags: [
      { name: 'google analytics' },
      { name: 'google ads' },
      { name: 'google tag' },
    ],
  },
  {
    name: 'Advanced Google Analytics',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Advanced-Google-Analytics-Course_Certificate.jpg',
    img: require('../images/certificates-img/Advanced-Google-Analytics-Course_Certificate.jpg'),
    date: 'Mar 2021 - Mar 2021',
    tags: [
      { name: 'google analytics' },
      { name: 'google ads' },
    ],
  },
  {
    name: 'Google Analytics for Beginners',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Google-Analytics-for-Beginners-Course_Certificate_Yanina_Trekhleb.jpg',
    img: require('../images/certificates-img/Google-Analytics-for-Beginners-Course_Certificate_Yanina_Trekhleb.jpg'),
    date: 'Mar 2021 - Mar 2021',
    tags: [
      { name: 'google analytics' },
      { name: 'google ads' },
    ],
  },
  {
    name: 'Learn Vue.js Course',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Learn-Vue.js-Course.jpg',
    img: require('../images/certificates-img/Learn-Vue.js-Course.jpg'),
    date: 'Jul 2020 - Aug 2020',
    tags: [
      { name: 'vue.js' },
      { name: 'javascript' },
    ],
  },
  {
    name: 'Learn SQL Course',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Learn-SQL-Course.jpg',
    img: require('../images/certificates-img/Learn-SQL-Course.jpg'),
    date: 'Jul 2020 - Jul 2020',
    tags: [
      { name: 'sql' },
      { name: 'database' },
    ],
  },
  {
    name: 'Learn JavaScript Course',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Learn-JavaScript-Course-Codecademy.jpg',
    img: require('../images/certificates-img/Learn-JavaScript-Course-Codecademy.jpg'),
    date: 'Jun 2020 - Jul 2020',
    tags: [
      { name: 'html/css' },
      { name: 'javascript' },
    ],
  },
  {
    name: 'Learn React.js: Part I Course',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Learn-React.js-Part-I-Codecademy-react.jpg',
    img: require('../images/certificates-img/Learn-React.js-Part-I-Codecademy-react.jpg'),
    date: 'Jun 2020 - Jul 2020',
    tags: [
      { name: 'html/css' },
      { name: 'javascript' },
      { name: 'react.js' },
    ],
  },
  {
    name: 'Building Interactive JavaScript Websites Course',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Building-Interactive-JavaScript-Websites-codecademy.jpg',
    img: require('../images/certificates-img/Building-Interactive-JavaScript-Websites-codecademy.jpg'),
    date: 'Jan 2019 - Feb 2020',
    tags: [
      { name: 'html/css' },
      { name: 'javascript' },
    ],
  },
  {
    name: 'Learn CSS Course',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/learn-css-codecademy.jpg',
    img: require('../images/certificates-img/learn-css-codecademy.jpg'),
    date: 'Dec 2018 - Jan 2019',
    tags: [
      { name: 'html/css' },
    ],
  },
  {
    name: 'Learn Responsive Design Course',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Learn-Responsive-Design-Course-Codecademy-responsive.jpg',
    img: require('../images/certificates-img/Learn-Responsive-Design-Course-Codecademy-responsive.jpg'),
    date: 'Dec 2018 - Jan 2019',
    tags: [
      { name: 'html/css' },
      { name: 'responsive design' },
      { name: 'javascript' },
    ],
  },
  {
    name: 'Responsive Web Design',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Responsive-Web%20Design-Coursera-2018.jpg',
    img: require('../images/certificates-img/Responsive-Web Design-Coursera-2018.jpg'),
    date: 'Sep 2018 - Oct 2018',
    tags: [
      { name: 'html/css' },
      { name: 'responsive design' },
      { name: 'javascript' },
    ],
  },
  {
    name: 'Responsive Website Basics: Code with HTML, CSS, and JavaScript',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/Responsive-Website-Coursera-2018.jpg',
    img: require('../images/certificates-img/Responsive-Website-Coursera-2018.jpg'),
    date: 'Sep 2018 - Oct 2018',
    tags: [
      { name: 'html/css' },
      { name: 'javascript' },
    ],
  },
  {
    name: 'HTML 5 App Development Fundamentals',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/softserve-basic-frontend-course-y-trekhleb.png',
    img: require('../images/certificates-img/softserve-basic-frontend-course-y-trekhleb.png'),
    date: 'Feb 2018 - Mar 2018',
    tags: [
      { name: 'html/css' },
      { name: 'javascript' },
    ],
  },
  {
    name: 'How to Make a Website with NameCheap Course',
    url: 'https://github.com/YaninaTrekhleb/portfolio/blob/main/src/images/certificates-img/How-to-Make-a-Website-with-NameCheap-Course-Codecademy.jpg',
    img: require('../images/certificates-img/How-to-Make-a-Website-with-NameCheap-Course-Codecademy.jpg'),
    date: 'Jan 2018 - Feb 2018',
    tags: [
      { name: 'html/css' },
      { name: 'javascript' },
    ],
  },
]
